<template>
  <b-form class="mt-3">
    <b-row>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="ชื่อเจ้าหน้าที่ผู้รับเรื่อง" label-for="officer">
          <vue-select
            label="text"
            v-model="officer"
            :options="officers"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import * as storeMaster from "@/store/api/master/index.js";
import InputFilter from "../../../filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {},
  // beforeMount(){
  // },
  setup(props) {
    const officers = [{ text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" }];

    const searchList = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        type: "text",
        options: [],
      },
      {
        id: "companySearch",
        label:
          "ข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาที่ร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "complainDetail",
        label: "รายละเอียดเรื่องร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "รายละเอียดเรื่องร้องทุกข์",
        type: "text",
        options: [],
      },
    ];

    return {
      search: searchList,
      props,
      officers,
      officer: { text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: null },
    };
  },
  mounted() {
    this.getOfficer();
  },
  methods: {
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
      this.search[3].value = null;
      this.search[4].value = null;
      this.search[5].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        code: this.search[0].value,
        name: this.search[1].value,
        company: this.search[2].value,
        startDate: this.search[3].value,
        endDate: this.search[4].value,
        value: this.search[5].value,
        userActive: this.officer != null ? this.officer.value : null,
      };

      this.$emit("handleSubmit", params);
    },
    getOfficer() {
      const _this = this;
      storeMaster
        .getOfficerInfoAll()
        .then(function(response) {
          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.user_id;
            setData.text = o.title_name + " " + o.fname + " " + o.lname;

            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.officers = officerUnique;

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
